import axios from "axios";
import store from "../../store/index";

function firstDefined() {
  for (var i = 0; i < arguments.length; i++) {
    var val = arguments[i];
    if (val !== undefined && val !== null) {
      return val;
    }
  }
  return undefined;
}

function extractApiErrorMessage(error, fallback) {
  const data = error.response && error.response.data;
  if (!data) {
    return error.message || fallback;
  }
  if (data.detail) {
    return data.detail;
  }
  if (data.errors) {
    const parts = [];
    Object.keys(data.errors).forEach(key => {
      const val = data.errors[key];
      if (Array.isArray(val)) {
        parts.push(...val);
      } else if (val) {
        parts.push(String(val));
      }
    });
    if (parts.length) {
      return parts.join(' ');
    }
  }
  if (data.title) {
    return data.title;
  }
  if (data.message) {
    return data.message;
  }
  return error.message || fallback;
}

const emptyForm = () => ({
  organizationName: '',
  url: '',
  isActive: true,
  rootUserEmail: '',
  rootUserName: '',
  connectionString: '',
  welcomeText: '',
  logoUrl: '',
});

const emptyErrors = () => ({
  organizationName: '',
  url: '',
  // rootUserName: '',
  // rootUserEmail: '',
  // connectionString: '',
});

export default {
  name: 'OrganizationModal',

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      isShowOrganizationModel: false,
      isEditMode: false,
      isSubmitting: false,
      editingRecordId: '',

      formData: emptyForm(),

      errors: emptyErrors()
    };
  },

  methods: {
    openOrganizationModal(org) {
      this.resetForm();

      if (org) {
        this.isEditMode = true;
        this.editingRecordId = firstDefined(org.id, '');
        this.formData = {
          organizationName: firstDefined(org.name, org.organizationName, ''),
          url: firstDefined(org.url, ''),
          isActive: firstDefined(org.active, org.isActive, true),
          rootUserEmail: firstDefined(org.rootEmail, org.rootUserEmail, ''),
          rootUserName: firstDefined(org.rootName, org.rootUserName, ''),
          connectionString: firstDefined(org.connectionString, ''),
          welcomeText: firstDefined(org.welcomeText, ''),
          logoUrl: firstDefined(org.logoUrl, ''),
        };
      } else {
        this.isEditMode = false;
      }

      this.isShowOrganizationModel = true;
    },

    closeOrganizationModal() {
      this.isShowOrganizationModel = false;
      this.resetForm();
    },

    resetForm() {
      this.formData = emptyForm();
      this.editingRecordId = '';
      this.errors = emptyErrors();
    },

    validateField(fieldName) {
      const field = this.formData[fieldName];

      switch (fieldName) {
        case 'organizationName':
          if (!field || String(field).trim().length === 0) {
            this.errors.organizationName = 'Organization name is required';
          } else if (String(field).trim().length < 3) {
            this.errors.organizationName = 'Organization name must be at least 3 characters';
          } else {
            this.errors.organizationName = '';
          }
          break;

        case 'url':
          if (!field || String(field).trim().length === 0) {
            this.errors.url = 'URL is required';
          } else {
            this.errors.url = '';
          }
          break;

        // case 'rootUserName':
        //   if (!field || String(field).trim().length === 0) {
        //     this.errors.rootUserName = 'Root user name is required';
        //   } else {
        //     this.errors.rootUserName = '';
        //   }
        //   break;

        // case 'rootUserEmail':
        //   if (!field || String(field).trim().length === 0) {
        //     this.errors.rootUserEmail = 'Root user email is required';
        //   } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field)) {
        //     this.errors.rootUserEmail = 'Please enter a valid email';
        //   } else {
        //     this.errors.rootUserEmail = '';
        //   }
        //   break;

        // case 'connectionString':
        //   if (!field || String(field).trim().length === 0) {
        //     this.errors.connectionString = 'Connection string is required';
        //   } else {
        //     this.errors.connectionString = '';
        //   }
        //   break;
      }
    },

    validateForm() {
      let isValid = true;

      ['organizationName', 'url'].forEach(field => {
        this.validateField(field);
        if (this.errors[field]) {
          isValid = false;
        }
      });

      return isValid;
    },

    buildPayload() {
      return {
        organizationName: this.formData.organizationName,
        url: this.formData.url,
        isActive: this.formData.isActive,
        rootUserEmail: this.formData.rootUserEmail,
        rootUserName: this.formData.rootUserName,
        connectionString: this.formData.connectionString,
        welcomeText: this.formData.welcomeText,
        logoUrl: this.formData.logoUrl,
      };
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      const payload = this.buildPayload();

      try {
        const response = this.isEditMode
          ? await axios.put(
              `${this.baseUrl}/admin/orginization/update?id=${encodeURIComponent(this.editingRecordId)}`,
              payload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.idToken}`
                }
              }
            )
          : await axios.post(
              `${this.baseUrl}/admin/orginization/create`,
              payload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.idToken}`
                }
              }
            );

        this.$emit(this.isEditMode ? 'organization-updated' : 'organization-created', response.data);
        alert(this.isEditMode ? 'Organization updated successfully' : 'Organization created successfully');
        this.closeOrganizationModal();
      } catch (error) {
        const message = extractApiErrorMessage(error, 'Failed to save organization');
        alert(`Error: ${message}`);
        console.error('Error saving organization:', error);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};